import { Box, Grid, Typography } from "@mui/material";
import { formatMoney } from "../../../../services/UtilsService";
import { CheckCircle } from "@mui/icons-material";

const ContractTerms = ({ contractTerms }) => {
  return (
    <Box
      maxWidth={true}
      style={{ backgroundColor: "#FFFFFF" }}
      borderRight={"1px solid #E9EBF0"}
      borderLeft={"1px solid #E9EBF0"}
      borderBottom={"1px solid #E9EBF0"}
      borderRadius={"0px 0px 8px 8px "}
    >
      <Grid container>
        <Grid container item xs={12}>
          <Grid
            item
            xs={6}
            padding={2}
            sx={{
              borderRight: "1px solid #E9EBF0",
              borderBottom: "1px solid #E9EBF0",
            }}
          >
            <Typography
              sx={{
                fontWeight: 400,
                color: "#8087A6",
              }}
              color="inherit"
              noWrap
            >
              Valor total
            </Typography>
          </Grid>
          <Grid
            item
            xs={6}
            padding={2}
            align={"end"}
            sx={{
              borderBottom: "1px solid #E9EBF0",
            }}
          >
            <Typography
              sx={{
                fontWeight: 400,
                color: "#00010C",
              }}
              color="inherit"
              noWrap
            >
              {formatMoney(contractTerms.grossAmount)}
            </Typography>
          </Grid>
        </Grid>

        <Grid container item xs={12}>
          <Grid
            item
            xs={6}
            padding={2}
            sx={{
              borderRight: "1px solid #E9EBF0",
              borderBottom: "1px solid #E9EBF0",
            }}
          >
            <Typography
              sx={{
                fontWeight: 400,
                color: "#8087A6",
              }}
              color="inherit"
              noWrap
            >
              (-) Juros de antecipação
            </Typography>
          </Grid>
          <Grid
            item
            xs={6}
            padding={2}
            align={"end"}
            sx={{
              borderBottom: "1px solid #E9EBF0",
            }}
          >
            <Typography
              sx={{
                fontWeight: 400,
                color: "#00010C",
              }}
              color="inherit"
              noWrap
            >
              {formatMoney(contractTerms.feeAmount)}
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      <Grid container item xs={12}>
        <Grid
          item
          xs={6}
          padding={2}
          sx={{
            borderRight: "1px solid #E9EBF0",
            borderBottom: "1px solid #E9EBF0",
          }}
        >
          <Typography
            sx={{
              fontWeight: 400,
              color: "#8087A6",
            }}
            color="inherit"
            noWrap
          >
            (-) IOF
          </Typography>
        </Grid>
        <Grid
          item
          xs={6}
          padding={2}
          align="end"
          sx={{
            borderBottom: "1px solid #E9EBF0",
          }}
        >
          <Typography
            sx={{
              fontWeight: 400,
              color: "#00010C",
            }}
            color="inherit"
            noWrap
          >
            {formatMoney(contractTerms.iof)}
          </Typography>
        </Grid>
      </Grid>

      <Grid container item xs={12}>
        <Grid
          item
          xs={6}
          padding={2}
          sx={{
            borderRight: "1px solid #E9EBF0",
            borderBottom: "1px solid #E9EBF0",
          }}
        >
          <Typography
            sx={{
              fontWeight: 400,
              color: "#8087A6",
            }}
            color="inherit"
            noWrap
          >
            (-) TAC
          </Typography>
        </Grid>
        <Grid
          item
          xs={6}
          padding={2}
          align="end"
          sx={{
            borderBottom: "1px solid #E9EBF0",
          }}
        >
          <Typography
            sx={{
              fontWeight: 400,
              color: "#00010C",
            }}
            color="inherit"
            noWrap
          >
            {formatMoney(contractTerms.tac)}
          </Typography>
        </Grid>
      </Grid>

      <Grid container item xs={12}>
        <Grid
          item
          xs={6}
          padding={2}
          sx={{
            borderRight: "1px solid #E9EBF0",
          }}
        >
          <Box display={"flex"}>
            <CheckCircle
              sx={{
                color: "#269800",
              }}
            />
            <Typography
              ml={"12px"}
              sx={{
                fontWeight: 400,
                color: "#269800",
              }}
              color="inherit"
              noWrap
            >
              Valor líquido à creditar
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={6} padding={2} align={"end"}>
          <Typography
            ml={"12px"}
            sx={{
              fontWeight: 600,
              color: "#269800",
            }}
            color="inherit"
            noWrap
          >
            {formatMoney(contractTerms.totalCreditAmount)}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ContractTerms;
